import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./styles.css";

import AttributesDisplay from "../../templates/AttributesDisplay";
import updateDisplayAttributes from "../../../services/UpdateDisplayAttributes";
import attributes from "../../../attribute-data/AttributeData";

export default React.memo(function AttributeCalculator() {
    const history = useHistory();
    const [strength, setStrength] = useState("0");
    const [agility, setAgility] = useState("0");
    const [intelligence, setIntelligence] = useState("0");
    const [spirit, setSpirit] = useState("0");
    const [constitution, setConstitution] = useState("0");
    const [strengthStatus, setStrengthStatus] = useState(
        attributes["strength"]
    );
    const [agilityStatus, setAgilityStatus] = useState(attributes["agility"]);
    const [intelligenceStatus, setIntelligenceStatus] = useState(
        attributes["intelligence"]
    );
    const [spiritStatus, setSpiritStatus] = useState(attributes["spirit"]);
    const [constitutionStatus, setConstitutionStatus] = useState(
        attributes["constitution"]
    );

    const handleClick = (e) => {
        e.preventDefault();
        history.push("/");
    };

    const handleChange = (e) => {
        const regexValue = e.target.value.replace(/\D+/g, "");
        const points = regexValue ? parseInt(regexValue) : 0;
        if (parseInt(regexValue) <= 1000 || !regexValue) {
            switch (e.target.id) {
                case "strength":
                    setStrength(regexValue);
                    setStrengthStatus(
                        updateDisplayAttributes(strengthStatus, points)
                    );
                    break;
                case "agility":
                    setAgility(regexValue);
                    setAgilityStatus(
                        updateDisplayAttributes(agilityStatus, points)
                    );
                    break;
                case "intelligence":
                    setIntelligence(regexValue);
                    setIntelligenceStatus(
                        updateDisplayAttributes(intelligenceStatus, points)
                    );
                    break;
                case "spirit":
                    setSpirit(regexValue);
                    setSpiritStatus(
                        updateDisplayAttributes(spiritStatus, points)
                    );
                    break;
                case "constitution":
                    setConstitution(regexValue);
                    setConstitutionStatus(
                        updateDisplayAttributes(constitutionStatus, points)
                    );
                    break;
                default:
                    break;
            }
        }
    };

    return (
        <div className="attribute-container">
            <AttributesDisplay
                strength={strength}
                agility={agility}
                intelligence={intelligence}
                spirit={spirit}
                constitution={constitution}
                strengthStatus={strengthStatus}
                agilityStatus={agilityStatus}
                intelligenceStatus={intelligenceStatus}
                spiritStatus={spiritStatus}
                constitutionStatus={constitutionStatus}
                handleChange={handleChange}
            />
            <button className="simulator-button" onClick={handleClick}>
                Simulador de Habilidades
            </button>
        </div>
    );
});
